import { breakpoints } from '@bnnvara/breakpoints';
import styled from 'styled-components';

export const BrandCardContainer = styled.div`
  max-height: 400px;
`;

export const NotificationContainer = styled.div`
  max-width: 575px;
  margin-top: 30px;
  position: absolute;
  z-index: 2;
`;

export const ProfileTitleContainer = styled.div`
  margin-top: 30px;

  ${breakpoints.md} {
    margin-top: 0px;
  }
`;
